export const ROUTES = {
  HOME: '/',
  NOT_FOUND: '*',
} as const;
